import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireFunctionsModule, FUNCTIONS_REGION } from '@angular/fire/functions';
import { environment } from '../environments/environment';
import { MainPageComponent } from './ui/main-page/main-page.component';
import { MainNavComponent } from './ui/main-nav/main-nav.component';
import { TopNavComponent } from './ui/top-nav/top-nav.component';
import { HomePageComponent } from './ui/home-page/home-page.component';
import { UserLoginComponent } from './ui/user-login/user-login.component';
import { UiModule } from './ui/ui.module';
import { AuthService } from './core/auth.service';
import { CoreModule } from './core/core.module';
import { DatePipe } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    CoreModule,
    UiModule,
    QRCodeModule
  ],
  providers: [DatePipe,
    { provide: FUNCTIONS_REGION, useValue: 'us-central1' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
